module.exports = __webpack_public_path__ + "img/menu_btn.6bf258e7.png";